<template>
    <div :class="rootClass" class="select-none p-4">
      <div :class="`${rootClass}__wrapper`">
        <div class="relative " v-for="(dataImage, index) in dataImagesLocal" :key="index" :class="`${rootClass}__item`">
        <div
          :class="classThumbnail(singleSelected.id, dataImage.id, dataImage.disabled)"
          @click="onSelectImage(dataImage)"
          v-if="!isMultiple"
        >
          <img
            :src="dataImage.src"
            rel="preload"
            :id="dataImage.id"
            :height="h"
            :width="w"
            :class="`${rootClass}__img`"
          />

          <label :for="dataImage.id" v-if="useLabel" :class="`${rootClass}__lbl`">{{dataImage.alt}}</label>
        </div>

        <div
          :class="classThumbnailMultiple(dataImage.id, dataImage.disabled)"
          @click="onSelectMultipleImage(dataImage)"
          v-if="isMultiple"
          class="relative"
        >
          <div class="absolute top-2/4 -mt-5 left-0  w-full select-none " v-if="dataImage.alt"> 
            <div class="bg-gray-700 bg-opacity-85 text-white mx-2 mt-1 p-2 font-bold shadow-xl text-center">{{ dataImage.alt }}</div>
          </div>
          <img
            :src="dataImage.src"
            rel="preload"
            :id="dataImage.id"
            :height="h"
            :width="w"
            :class="`${rootClass}__img`"
            
          />

          <label :for="dataImage.id" v-if="useLabel" :class="`${rootClass}__lbl`">{{dataImage.alt}}</label>
          </div>
      
          <div class="absolute -bottom-4 w-full"  v-show="classWeight(dataImage.id)">
            <div class="px-5 pt-2 pb-2 bg-gray-200 rounded-2xl  mx-10 drop-shadow-xl">
                <vue-slider  v-model="dataImage.weight" :min="1" :max="5" :interval="0.5" :marks="false" :included="true"/>
              </div>
          </div>


          
        </div>
       
      </div>
    </div>
  </template>
  
  <script>
  import VueSlider from 'vue-slider-component'
export default {
  components: {
    VueSlider,
  },
  name: "vue-select-image",
  props: {
    dataImages: {
      type: Array,
      default: () => []
    },
    selectedImages: {
      type: Array,
      default: () => []
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isMultipleSingleSelect: {
      type: Boolean,
      default: false
    },
    useLabel: {
      type: Boolean,
      default: false
    },
    rootClass: {
      type: String,
      default: "vue-select-image"
    },
    activeClass: {
      type: String,
      default: "--selected"
    },
    h: {
      type: String,
      default: "auto"
    },
    w: {
      type: String,
      default: "auto"
    },
    limit: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      singleSelected: {
        id: ""
      },
      multipleSelected: []
    };
  },
  computed: {
    dataImagesLocal: function() {
      return this.dataImages || [];
    }
  },
  created(){
   
  },
  updated(){

  },
  mounted() {

    // set initial selectedImage
    this.setInitialSelection();
  },
  methods: {
    classWeight(id){
      if (this.isExistInArray(id)) {
        return true
      } else {
        return false
      }
    },
    classThumbnail(selectedId, imageId, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      if (isDisabled) {
        return `${baseClass} ${baseClass}--disabled`;
      }
      if (selectedId === imageId) {
        return `${baseClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseClass}`;
    },
    classThumbnailMultiple(id, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `${baseClass} is--multiple`;
      if (isDisabled) {
        return `${baseMultipleClass} ${baseClass}--disabled`;
      }
      if (this.isExistInArray(id)) {
        return `${baseMultipleClass} ${baseClass}${this.activeClass}`;
      }
      return `${baseMultipleClass}`;
    },
    onSelectImage(objectImage) {
      if (!objectImage.disabled) {
        this.singleSelected = Object.assign({}, this.singleSelected, objectImage);
        this.$emit("onselectimage", objectImage);
      }
    },

    isExistInArray(id) {  
 
      return this.multipleSelected.find(item => {
        return id === item.id;
      });
    },
    removeFromSingleSelected() {
      this.singleSelected = {};
      this.$emit("onselectimage", {});
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter(item => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit("onselectmultipleimage", this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      if (!objectImage.disabled) {
        if (!this.isExistInArray(objectImage.id)) {
          if (this.limit > 0) {
            if (this.multipleSelected.length < this.limit) {
              this.multipleSelected.push(objectImage);
              this.$emit("onselectmultipleimage", this.multipleSelected);
            } else {
              this.$emit("onreachlimit", this.limit);
            }
          } else {
            this.multipleSelected.push(objectImage);
            this.$emit("onselectmultipleimage", this.multipleSelected);
          }
        } else {
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit("onselectmultipleimage", this.multipleSelected);
        }
      }
    },
    setInitialSelection() {
     console.log(this.selectedImages)
      if (this.selectedImages) {
        if (!this.isMultiple && this.selectedImages.length === 1) {
          this.singleSelected = Object.assign({}, this.selectedImages[0]);
        } else {
          
           this.multipleSelected = [].concat(this.selectedImages);
        }
      }
    }
  }
};
</script>